export const SHOP_PAGE_TEXTS = {
  '/shop': 'SELECT GAME',
  '/shop/select-game': 'SELECT GAME',
  '/shop/select-case': 'SELECT GAME',
  '/shop/cash': `${new Date().toLocaleDateString('en-US', { 
    month: 'long', 
    day: 'numeric', 
    year: 'numeric' 
  })}`,
  '/shop/vip': 'Unlock VIP!!'
} as const;